import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  // The evaluator count is unbounded, so the table scrolls sideways inside
  // the modal instead of stretching it.
  scrollWrap: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  headerRow: {
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  bodyRow: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  questionHeaderCell: {
    textAlign: 'left',
    padding: theme.spacing(1.5),
    width: '38%',
    minWidth: 220,
  },
  questionColumnLabel: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold as number,
  },
  evaluatorHeaderCell: {
    textAlign: 'center',
    padding: theme.spacing(1.5),
    minWidth: 130,
    verticalAlign: 'top',
  },
  evaluatorHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    // Outweighs the tag's own class, so the tag text reads bold.
    '& $yourScorecardTag': {
      fontWeight: theme.typography.fontWeightBold as number,
    },
  },
  evaluatorName: {
    fontWeight: theme.typography.fontWeightBold as number,
    color: theme.palette.text.primary,
  },
  pendingEvaluatorName: {
    fontWeight: theme.typography.fontWeightBold as number,
    color: theme.palette.text.secondary,
  },
  submittedDate: {
    fontSize: 12,
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  },
  invitedDate: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  yourScorecardTag: {
    marginTop: theme.spacing(0.25),
  },
  questionCell: {
    padding: theme.spacing(1.5),
    verticalAlign: 'top',
  },
  questionEntry: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  questionNumber: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  questionText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  questionType: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  answerCell: {
    padding: theme.spacing(1.5),
    textAlign: 'center',
    verticalAlign: 'top',
  },
  answer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  answerValue: {
    fontWeight: theme.typography.fontWeightBold as number,
    color: theme.palette.text.primary,
  },
  answerNote: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  },
  emptyCell: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  },
  summaryRow: {
    background: theme.palette.background.default,
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  summaryLabelCell: {
    padding: theme.spacing(1.5),
    textAlign: 'left',
  },
  summaryLabel: {
    fontWeight: theme.typography.fontWeightBold as number,
    color: theme.palette.text.primary,
  },
  summaryValueCell: {
    padding: theme.spacing(1.5),
    textAlign: 'center',
    // Outweighs the tag's own class, so the pill hugs its label instead of
    // filling the cell.
    '& $recommendationTag': {
      display: 'inline-block',
      fontWeight: theme.typography.fontWeightBold as number,
    },
  },
  recommendationTag: {},
  summaryScore: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeightBold as number,
    color: theme.palette.text.primary,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6),
  },
}));
